/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetUserPointActionReqVo
 */
export interface SetUserPointActionReqVo {
    /**
     * 用户积分数据编号
     * @type {number}
     * @memberof SetUserPointActionReqVo
     */
    id: number;
    /**
     * 操作类型 1入积分 0出积分
     * @type {number}
     * @memberof SetUserPointActionReqVo
     */
    intOutType: number;
    /**
     * 积分数量
     * @type {number}
     * @memberof SetUserPointActionReqVo
     */
    amount: number;
    /**
     * 内容
     * @type {string}
     * @memberof SetUserPointActionReqVo
     */
    content?: string;
}

/**
 * Check if a given object implements the SetUserPointActionReqVo interface.
 */
export function instanceOfSetUserPointActionReqVo(value: object): value is SetUserPointActionReqVo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('intOutType' in value) || value['intOutType'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function SetUserPointActionReqVoFromJSON(json: any): SetUserPointActionReqVo {
    return SetUserPointActionReqVoFromJSONTyped(json, false);
}

export function SetUserPointActionReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetUserPointActionReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'intOutType': json['intOutType'],
        'amount': json['amount'],
        'content': json['content'] == null ? undefined : json['content'],
    };
}

export function SetUserPointActionReqVoToJSON(json: any): SetUserPointActionReqVo {
    return SetUserPointActionReqVoToJSONTyped(json, false);
}

export function SetUserPointActionReqVoToJSONTyped(value?: SetUserPointActionReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'intOutType': value['intOutType'],
        'amount': value['amount'],
        'content': value['content'],
    };
}

